import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVivinoComponent } from './simple-icons-vivino.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVivinoComponent ],
    exports:      [ SimpleIconsVivinoComponent ],
    bootstrap:    []
})
export class SimpleIconsVivinoModule {}
